// extracted by mini-css-extract-plugin
module.exports = {"options":"custom-cta_options__1fBRB","onError":"custom-cta_onError__3TblW","colourItem":"custom-cta_colourItem__2dewO","remove":"custom-cta_remove__1SteK"};